/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid, GridItem } from "@chakra-ui/react";
import { useEffect, useState } from "react";
// Components
import { Outlet, useParams } from "react-router-dom";
import NotesSection from "../../Components/Eddss/NotesSection";
import UserInfoPanel from "../../Components/Eddss/UserInfoPanel";
import apiClient from "../../utils/ApiClient/apiClientAxios";

const EdssLayout = () => {
  const [edssData, setEdssData] = useState({});
  const [personInfo, setPersonInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingPerson, setIsFetchingPerson] = useState(false);
  const [formState, setFormState] = useState({});
  const { id, personID } = useParams();

  const fetchEdssCase = async (id, personID) => {
    setIsLoading(true);
    try {
      const response = await apiClient.get("/getEDSSCase", {
        params: { id, person: personID },
      });

      setEdssData(response.data);
    } catch (error) {
      if (error.response) {
        console.error(
          `EDSS case fetch failed: ${error.response.status} - ${error.response.statusText}`,
          error.response.data
        );
      } else {
        console.error(
          "Network or unexpected error while fetching EDSS case",
          error
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id && personID) {
      fetchEdssCase(id, personID);
    }
  }, [id, personID]);

  const mutateEdssData = (mutateFn) => {
    setEdssData((prev) => {
      const updated = structuredClone(prev);
      mutateFn(updated);
      return updated;
    });
  };
  const fetchUpdatedPerson = async () => {
    if (!personID) return;
    setIsFetchingPerson(true);

    try {
      const response = await apiClient.get(`/getPerson`, {
        params: { id: personID },
      });

      setPersonInfo(response.data);
    } catch (error) {
      console.error("❌ Failed to fetch person data:", error);
    } finally {
      setIsFetchingPerson(false);
    }
  };

  useEffect(() => {
    fetchUpdatedPerson();
  }, [personID]);
  return (
    <Box m={3}>
      <Box mt={2}>
        <Grid h="82vh" templateColumns="1fr 5fr 1fr" gap={4}>
          {/* Left Panel - User Information */}
          <GridItem bg="aliceblue" p={2} borderRadius="md" boxShadow="md">
            <UserInfoPanel
              userInfo={personInfo}
              data={edssData}
              isFetchingPerson={isFetchingPerson}
              fetchEdssCase={fetchEdssCase}
              edssData={edssData}
              setEdssData={setEdssData}
              setFormState={setFormState}
            />
          </GridItem>

          {/* Middle Panel - Case Details with Tabs */}
          <GridItem maxH="100vh" overflowY="scroll" p={4}>
            <Outlet
              context={{
                edssData,
                isLoading,
                mutateEdssData,
                fetchUpdatedPerson,
                setPersonInfo,
                fetchEdssCase,
                formState,
                setFormState,
              }}
            />
          </GridItem>

          {/* Right Panel - Notes Section */}
          <GridItem bg="aliceblue" p={2} borderRadius="md" boxShadow="md">
            <NotesSection data={edssData} isLoading={isLoading} />
          </GridItem>
        </Grid>
      </Box>
    </Box>
  );
};

export default EdssLayout;
